import React, { type ReactElement } from 'react';

import { AUTHENTICATION_NEED_HELP } from '@framework/constants/insights';
import { initFreshChatWithoutUser } from '@framework/freshchat';
import useTranslation from '@framework/hooks/useTranslation';
import { isWindowDefined } from '@framework/utils';

import useSendStatelessInsight from '@hooks/useSendStatelessInsight';

import { Button, Text } from 'styled-system';

const GetHelpAction = (): ReactElement => {
    const { t, i18n } = useTranslation();
    const sendStatelessInsight = useSendStatelessInsight();

    const handleClick = () => {
        const freshchatWidget = isWindowDefined() && window.fcWidget;
        if (freshchatWidget) {
            initFreshChatWithoutUser(i18n.language);
            freshchatWidget.open();
        }
        sendStatelessInsight(AUTHENTICATION_NEED_HELP);
    };

    return (
        <Button size="small" type="ghost" onClick={handleClick}>
            <Text>{t('Contact support')}</Text>
        </Button>
    );
};

export default GetHelpAction;
